// Toasts a Download Center link when a data-export task completes (drops from the list).
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Button } from '@bettercomp/ui-components';
import { selectExportTasks } from 'redux/backgroundTasks/selectors';

import { showNotification } from '../common/function';
import { PATH } from '../common/constants';

// A real link in a new tab, so the user keeps the page they exported from.
const toastBody = (
  <div>
    Your file is available for download in the <br />
    <Button
      type="link"
      href={PATH.DOWNLOADS}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="downloadCenterButton"
    >
      Download Center
    </Button>
  </div>
);

export function useExportTaskCompleteEvent() {
  const exportTasks = useSelector(selectExportTasks);
  const [previousExportTasks, setPreviousExportTasks] = useState(exportTasks);

  useEffect(() => {
    if (previousExportTasks.length > exportTasks.length) {
      showNotification(toastBody as any, 'Export Available', 'success');
    }

    setPreviousExportTasks(exportTasks);
  }, [exportTasks, previousExportTasks.length]);
}
